import React from 'react';
import { withStyles } from "tss-react/mui";
import CircularProgress from '@mui/material/CircularProgress';
import styles from './styles';
import EventButton from 'components/EventButton';

class ProgressButton extends React.Component {
    render() {
        const { active, classes, disabled } = this.props;

        return (
            <div className={classes.wrapper}>
                <EventButton variant="contained" color="primary" disabled={disabled || active} onClick={this.props.onClick}>
                    {this.props.text}
                </EventButton>
                {active && <CircularProgress size={24} className={classes.progress} />}
            </div>
        );
    }
}

export default withStyles(ProgressButton, styles);